'use client';

import { useEffect, useState } from 'react';

export const SEARCH_PLACEHOLDERS = [
  'O que você busca?',
  'Busque pela especialidade',
  'Busque pelo exame',
  'Busque pelo nome do médico',
  'Busque pelo nome do profissional',
  'Busque pelo laboratório',
] as const;

const ROTATION_INTERVAL_MS = 2000;

export function useRotatingPlaceholder() {
  const [placeholderIndex, setPlaceholderIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(
      () => setPlaceholderIndex((prev) => (prev + 1) % SEARCH_PLACEHOLDERS.length),
      ROTATION_INTERVAL_MS,
    );
    return () => clearInterval(interval);
  }, []);

  return SEARCH_PLACEHOLDERS[placeholderIndex];
}
